import React from 'react'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

import { IconButton } from '@slite/components'
import { ChevronUpIcon } from '@slite/icons'

import type { FAQSection } from './types'

export const SingleFAQ = ({
  section,
  defaultIsOpen,
}: {
  section: FAQSection
  defaultIsOpen: boolean
}) => {
  const intl = useIntl()
  const [isOpen, setIsOpen] = React.useState(defaultIsOpen)
  return (
    <div
      key={section.question?.toString()}
      className="flexbox flexbox-gap-32 font-size-larger shade-05"
    >
      <div className="flexbox flexbox-column flexbox-gap-4 flexbox-grow">
        <h4
          className="pointer font-size-4-not-small font-size-6 font-weight-semibold line-height-copy"
          onClick={() => setIsOpen(!isOpen)}
        >
          {section.question}
        </h4>
        <p
          className={classNames(
            'font-weight-light overflow-hidden line-height-copy font-size-6-not-small font-size-7',
            {
              'margin-top-12': isOpen,
            }
          )}
          style={{
            maxHeight: isOpen ? '100%' : 0,
            transition: isOpen ? 'all 0.2s ease-in-out' : 'none',
          }}
        >
          {section.answer}
        </p>
      </div>
      <div className="flexbox">
        <IconButton
          size="small"
          variant="tertiary"
          icon={ChevronUpIcon}
          className={isOpen ? '' : 'rotate-180'}
          onClick={() => setIsOpen(!isOpen)}
          aria-label={
            isOpen
              ? intl.formatMessage({
                  id: 'faq.collapse',
                  defaultMessage: 'Collapse',
                })
              : intl.formatMessage({
                  id: 'faq.expand',
                  defaultMessage: 'Expand',
                })
          }
        />
      </div>
    </div>
  )
}
